module.exports = "<div class=\"wc-collapse\" :class=\"{'borderless': borderless}\">\n  <slot></slot>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/src/wc-ui/components/collapse/collapse.html
// module id = 979
// module chunks = 0